import React from 'react';
import { useTranslation } from 'react-i18next';

import AmateurDestemmer from "../../../assets/images/AmateurDestemmer.png";
import Oscyllis from "../../../assets/images/Oscyllis.png";
import Professionaldester from "../../../assets/images/Professionaldester.png";

function DestemmerCrusher() {
  const { t } = useTranslation();

  const products = [
    {
      name: t("Oscillys Destemmer"),
      description: t(
        "This exclusive de-stemming system works without a beater, de-stemming shaft or rotating cage. Oscillys relies on the high amplitude oscillation of a cage to detach the grapes from the stalk by inertia. It ensures efficient and high-quality stalk separation while reducing the volumes of juice produced and preserving the condition of the stalk."
      ),
      image: Oscyllis,
    },
    {
      name: t("Amateur Destemmer"),
      description: t(
        "A simpler, but very effective and quality-oriented machine, which will allow the user to receive and process the product in the needed time."
      ),
      image: AmateurDestemmer,
    },
    {
      name: t("Professional Destemmer"),
      description: t(
        "Professional destemmer-crushers are designed to bring the harvest into the destemmer cage progressively and without shocks. The shaft rotates smoothly to avoid shearing the grapes. The shaft allows the screen to be unclogged and avoids trituration of the stalks."
      ),
      image: Professionaldester,
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.image} alt={product.name} />
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default DestemmerCrusher;